import { useState } from 'react';
import { FrameDetailsModal } from 'components/pages/DealWithLines/common/FrameDetailsModal/FrameDetailsModal';
import { ButtonColor, AllocationFrameListProps } from './AllocationFrameList.types';

export const AllocationFrameList = ({
  assets = [],
  actionButton,
  buttonColor = ButtonColor.PRIMARY,
  isDisabled = false,
}: AllocationFrameListProps): React.ReactElement => {
  const [showFrameListModal, setShowFrameListModal] = useState(false);

  const onActionButtonClick = (): void => setShowFrameListModal(true);

  return (
    <>
      {actionButton?.(onActionButtonClick) ?? (
        <button
          type="button"
          className={`mt-2 ${buttonColor}`}
          onClick={onActionButtonClick}
          data-test-id="deal-summary-frame-list-btn"
          disabled={isDisabled}
        >
          Frame list
        </button>
      )}
      <FrameDetailsModal
        assets={assets}
        isOpen={showFrameListModal}
        onClose={() => setShowFrameListModal(false)}
        hasExportButton
      />
    </>
  );
};
